var validateMobile = (rule, value, callback) => {
    if (!value) {
        callback(new Error('Input PhoneNumber'));
    } else if (!/^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$/.test(value)) {
        callback(new Error('Input Correct PhoneNumber'));
    } else {
        callback();
    }
};
var validateEmail = (rule, value, callback) => {
    if (/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)) {
        callback();
    } else {
        callback(new Error("Input Correct Mail Address"));
    }
};
var validateNumberValueInput = (rule, value, callback) => {
  //输入为空
  if (!value) {
    callback(new Error("Input!"));
  } else   if(!/^[0-9]+$/.test(value)){
    callback(new Error("Input Number!"));
  } else {
    //自定义验证
    callback()
  }
}
export default {
    CutQty:[
      {
        validator: validateNumberValueInput,
        trigger: "blur"
      }
    ],
    mobile: [{
        validator: validateMobile,
        trigger: "blur"
    }],
    name: [{
        required: true,
        message: "Input Name",
        trigger: "blur"
    }],
    realName: [{
        required: true,
        message: "Input RealName",
        trigger: "blur"
    }],
    password: [{
        required: true,
        message: "Input Password",
        trigger: "blur"
    },
        {
            min: 8,
            max: 16,
            message: "8-16 Length PassWord",
            trigger: "blur"
        }
    ],
    rePassword: [{
        required: true,
        message: "Input PassWord",
        trigger: "blur"
    },
        {
            min: 8,
            max: 16,
            message: "8-16 Length PassWord",
            trigger: "blur"
        },
    ],
    phone: [{
        required: true,
        message: "Input PhoneNumber",
        trigger: "blur"
    },
        {
            validator: validateMobile,
            trigger: "blur"
        }
    ],
    email: [{
        required: true,
        message: "Input Mail Address",
        trigger: "blur"
    },
        {
            validator: validateEmail,
            trigger: "blur"
        }
    ],
    description: [{
        required: true,
        message: "请输入描述信息",
        trigger: "blur"
    }],
    groupId: [{
        type: "number",
        required: true,
        message: "请选择数据分组",
        trigger: "blur"
    }],
    value: [{
        required: true,
        message: "请输入码本数据值",
        trigger: "blur"
    }]
}



// WEBPACK FOOTER //
// ./src/rules/index.js